'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isImmutable = exports.isImmutable = function isImmutable(appState) {
  return typeof appState.get === 'function';
};

exports.default = {
  isImmutable: isImmutable
};